import downloadFile from "@/helpers/download-file";
export default {
    Operators: {
        getList(params) {
            return axios.get("/admin/operator", { params }).then(resp => resp.data);
        },
        get(id) {
            return axios.get(`/admin/operator/${id}`).then(resp => resp.data);
        },
        add(operator) {
            return axios.post("/admin/operator", operator).then(resp => resp.data);
        },
        remove(id) {
            return axios.delete(`/admin/operator/${id}`).then(resp => resp.data);
        },
        block(id, blocked) {
            return axios.put(`/admin/operator/${id}/block`, { blocked }).then(resp => resp.data);
        },
        update(id, operator) {
            return axios.put(`/admin/operator/${id}`, operator).then(resp => resp.data);
        },
    },
    Chat: {
        async getList() {
            const { data } = await axios.get("/admin/chats");

            return data;
        },
        async getMessages(user_id, page = 1) {
            const { data } = await axios.get("/admin/chats/messages", { params: { page, user_id } });

            return data;
        },
        async deleteMessage(message_id) {
            await axios.delete(`/admin/chats/messages/${message_id}`);
        },
        async sendMessage(user_id, message, files) {
            const formData = new FormData();
            formData.append("body", message);
            formData.append("user_id", user_id);
            for (const idx in files) {
                const file = files[idx];
                formData.append(`files[${idx}][attachment]`, file.src);
            }
            const { data } = await axios.post("/admin/chats/messages", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            return data;
        },

        async fileDownload(messageId, fileId, token) {
            const url = `/api/admin/chats/messages/${messageId}/file/${fileId}`;
            downloadFile(url, token);
        },
    },
    Organizers: {
        async getList(params) {
            const { data } = await axios.get("/admin/organizers", { params });

            return data;
        },
        async getListForOrganaizer(params){
            const { data } = await axios.get("/templates/organizers", { params });

            return data;
        },
        async get(id) {
            const { data } = await axios.get(`/admin/organizers/${id}`);

            return data;
        },
        async getForOrganizer(id) {
            const { data } = await axios.get(`/templates/organizers/${id}`);

            return data;
        },
        async toggleState(id, is_active) {
            const { data } = await axios.put(`/admin/organizers/${id}/active`, {
                is_active,
            });

            return data;
        },
        async toggleStateForOrganizer(id, is_active) {
            const { data } = await axios.put(`/templates/organizers/${id}/active`, {
                is_active,
            });

            return data;
        },
        async update(id, newOrganizer) {
            const { data } = await axios.put(`/admin/organizers/${id}`, newOrganizer);

            return data;
        },
        async updateOrganizer (id, newOrganizer) {
            const { data } = await axios.put(`/templates/organizers/${id}`, newOrganizer);

            return data;
        },
        async create(organizer) {
            const { data } = await axios.post("admin/organizers", organizer);

            return data;
        },
        async createForOrganizer(organizer) {
            const { data } = await axios.post("templates/organizers", organizer);

            return data;
        },
        async delete(id) {
            const { data } = await axios.delete(`/admin/organizers/${id}`);

            return data;
        },
    },
    OrganizerUsers: {
        async getList(params) {
            const {data, meta} = await axios.get("/admin/organizerUsers", {params});

            return data;
        },
        async getList2(params) {
            const {data, meta} = await axios.get("/templates/organizerUsers", {params});

            return data;
        }
    },
    Users: {
        async getList(params) {
            const { data } = await axios.get("/admin/profiles", { params });

            return data;
        },
        get(id) {
            return axios.get(`/admin/profiles/${id}`);
        },
        getAccounts(id) {
            return axios.get(`/admin/profiles/${id}/accounts`);
        },
        refillAccount(id, summ) {
            return axios.post(`/admin/profiles/${id}/accounts/refill`, {
                summ: summ,
            });
        },
        withdrawAccount(id, summ) {
            return axios.post(`/admin/profiles/${id}/accounts/withdraw`, {
                summ: summ,
            });
        },
        async update(id, profileData) {
            const { data } = await axios.put(`/admin/profiles/${id}`, profileData);

            return data;
        },
        async getDocuments(id) {
            const { data } = await axios.get(`/admin/profiles/${id}/documents`);

            return data;
        },
        async getCertificate(id) {
            const { data } = await axios.get(`/admin/profiles/${id}/certificate`);

            return data;
        },
        async acceptProfile(id) {
            const { data } = await axios.post(`/admin/profiles/${id}/accept`);

            return data;
        },
        async declineProfile(id, message) {
            const { data } = await axios.post(`/admin/profiles/${id}/decline`, { message });

            return data;
        },
        deleteProfile(id) {
            return axios.delete(`/admin/profiles/${id}`);
        },
        async sendEmail(id, message) {
            const { data } = await axios.post(`/admin/profiles/${id}/sendEmail`, { message });

            return data;
        },
    },
};
